// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reservation-steps[data-v-3a47e8d3]{font-size:18px}.reservation-steps[data-v-3a47e8d3] h2.heading{padding-bottom:10px;padding-top:5px}.hotel-voucher-video[data-v-3a47e8d3]{margin:10px auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
